<template>
  <div class="add_main">
    <el-form ref="goodDetailForm" :model="goodDetailForm" label-width="140px">
      <span class="blue-txt">选择类型</span>
      <el-form-item label="商品类型：">
        <el-cascader
            ref="cascader"
            v-model="goodDetailForm.categoryId"
            :props="{ emitPath: false }"
            :show-all-levels="true"
            :options="productNavTypeTreeList"
            @change="handleChange"
            placeholder="请选择类型"
        ></el-cascader>
      </el-form-item>
      <span class="blue-txt">基础信息</span>
      <el-form-item label="商品名称：">
        <el-input
            v-model="goodDetailForm.name"
            placeholder="请输入商品名称"
            clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="商品型号：">
        <el-input
            v-model="goodDetailForm.model"
            placeholder="请输入商品型号"
            clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="商品品牌：">
        <el-autocomplete
            v-model="goodDetailForm.brandName"
            :fetch-suggestions="querySearchAsync"
            placeholder="请选择品牌 可搜索"
            @select="handleSelect"
        ></el-autocomplete>
      </el-form-item>
      <!-- <el-form-item label="商品排序：">
        <el-input
            v-model="goodDetailForm.order"
            placeholder="数值越高越靠后"
            clearable
        ></el-input>
      </el-form-item> -->
      <el-form-item label="服务内容：">
        <el-input
            type="textarea"
            v-model="goodDetailForm.serviceContent"
            placeholder="例如：正品保障、7天无理由退换货、15天换货，多个请使用中文顿号分隔"
        ></el-input>
      </el-form-item>
      <el-form-item label="商品编码：">
        <el-input
            v-model="goodDetailForm.code"
            placeholder="请输入商品编码"
            clearable
        ></el-input>
      </el-form-item>
      <!-- <el-form-item label="商品归属：">
        <el-radio-group v-model="goodDetailForm.sourceType">
          <el-radio :label="0">自有商品</el-radio>
          <el-radio :label="1">选择供应商</el-radio>
          <el-select
              filterable
              v-model="goodDetailForm.sourceId"
              placeholder="请选择供应商（可搜索）"
              clearable
              @blur="select_blur_supplier"
            >
            <el-option
              v-for="(item,index) in supplierList"
              :key="index"
              :label="item.proSupplierName"
              :value="item.id">
            </el-option>
          </el-select>
        </el-radio-group>
      </el-form-item> -->

      <el-form-item label="商品归属：">
        选择供应商&nbsp;&nbsp;
        <el-select
            filterable
            v-model="goodDetailForm.sourceId"
            placeholder="请选择供应商（可搜索）"
            clearable
            @blur="select_blur_supplier"
        >
          <el-option
              v-for="(item,index) in supplierList"
              :key="index"
              :label="item.proSupplierName"
              :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="选择规格模板：">
        <el-select v-model="goodDetailForm.propertyGroupId" disabled>
          <el-option v-for="(item, index) in propertyList" :key="index" :label="item.name" :value="item.id"></el-option>
        </el-select>
        <!-- <el-button style="margin-left: 20px;" type="primary" v-if="!createSkuList[0]" @click="goJumpAttributeTem">
          自定义属性
        </el-button> -->
      </el-form-item>
      <span class="blue-txt">商品描述</span>
      <el-form-item label="商家图片：" style="margin-bottom: 50px">
        <draggable
            :list="goodDetailForm.pictures"
            :group="{ sort: true, animation: 500 }"
        >
          <div
              class="img_box"
              v-for="(item, index) in goodDetailForm.pictures"
              :key="index"
          >
            <p class="del_box" @click.stop="handleDelPic(item,index)">
              <img src="../../../assets/del-icon.png" alt/>
            </p>
            <img
                :src="item.url"
                alt
                @click.stop="handleBigPic(item.url)"
            />
            <p class="set_main">
              <el-button size="mini" @click.stop="setMain(item, index)">{{
                  item.type == 0 ? "主图" : "设为主图"
                }}
              </el-button>
            </p>
          </div>
          <span style="color:#f40000;position: absolute;bottom:0;" v-if="isShowNinePic">最多添加9张</span>
          <el-upload
              v-if="!isShowNinePic"
              class="img-uploader"
              action
              :show-file-list="false"
              :auto-upload="false"
              :on-change="handleBusinessPic"
              multiple
          >
            <i class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </draggable>
      </el-form-item>
      <el-form-item label="商品描述：" style="margin-top: 50px">
        <weditor
            @catchData="catchDetailData"
            :isAddEditor="true"
            v-model="goodDetailForm.introduce"
            :content="goodDetailForm.introduce"
            :editorHeight="500"
        ></weditor>
      </el-form-item>
    </el-form>
    <div class="sbmit_info">
      <el-button type="primary" v-preventClick @click="addOrUpdata">保存并设置SKU</el-button>
    </div>
    <div class="tab_box" v-if="spuId">
      <span class="blue-txt">SKU信息</span>
      <div>
        <el-form label-width="140px" :inline="true">
          <el-form-item label="选择属性组合：">
            <el-button @click="selectScep" size="small" type="success">添加</el-button>
          </el-form-item>
        </el-form>
        <div v-if="createSkuList[0]">
          <el-table
              :row-class-name="tableRowClassName"
              :data="createSkuList"
              ref="isExpand"
              style="width: 100%">
            <el-table-column type="expand">
              <template slot-scope="props">
                <el-table
                    :data="props.row.saleableSkuPriceItems"
                    style="width: 100%">
                  <el-table-column
                      prop="resellerName"
                      label="分销商"
                      width="180">
                  </el-table-column>
                    <el-table-column
                            label="供货价">
                        <template slot-scope="props">
                            <el-input class="cost-price" type="number" placeholder="供货价" v-model="props.row.supplyPrice"
                                      style="width:100%;"></el-input>
                        </template>
                    </el-table-column>
                  <el-table-column
                      label="市场价"
                      width="180">
                    <template slot-scope="props">
                      <el-input v-if="props.row.priceType == 2" class="cost-price" type="number" placeholder="市场价" v-model="props.row.marketPrice"
                                style="width:100%;"></el-input>
                        <el-input v-if="props.row.priceType == 1" disabled class="cost-price" type="number" v-model="props.row.supplyPrice"
                                  style="width:100%;"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column
                      label="商家价">
                    <template slot-scope="props">
                      <el-input v-if="props.row.priceType == 2" class="cost-price" type="number" placeholder="商家价" v-model="props.row.merchantsPrice"
                                style="width:100%;"></el-input>
                        <el-input v-if="props.row.priceType == 1" disabled class="cost-price" type="number" v-model="props.row.supplyPrice"
                                  style="width:100%;"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column
                      label="零售价">
                    <template slot-scope="props">
                      <el-input v-if="props.row.priceType == 2" class="cost-price" type="number" placeholder="零售价" v-model="props.row.retailPrice"
                                style="width:100%;"></el-input>
                        <el-input v-if="props.row.priceType == 1" disabled class="cost-price" type="number" v-model="props.row.supplyPrice"
                                  style="width:100%;"></el-input>

                    </template>
                  </el-table-column>
                  <el-table-column
                      label="上下架">
                    <template slot-scope="props">
                      <el-switch
                          v-model="props.row.isShelves"
                          active-color="#13ce66"
                          inactive-color="#ccc">
                      </el-switch>
                    </template>
                  </el-table-column>
                  <el-table-column
                      label="远程审核状态">
                    <template slot-scope="props">
                      <el-tag v-if="props.row.remoteShelvesAuditStatus == 2" type="success">审核通过</el-tag>
                      <el-tag v-if="props.row.remoteShelvesAuditStatus == 0" type="info">待提交</el-tag>
                      <el-tag v-if="props.row.remoteShelvesAuditStatus == 1" type="danger">待审核</el-tag>
                      <el-tag v-if="props.row.remoteShelvesAuditStatus == 3" type="warning">审核不通过</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column
                      prop="desc"
                      label="备注">
                  </el-table-column>
                </el-table>
              </template>
            </el-table-column>
            <el-table-column
                label="属性名称">
              <template slot-scope="scoped">
                <el-input v-for="(spec,index) in scoped.row.propertyJsonArr.PropertyList" :key="index" v-model="spec.PropertyValueString" @change="(value) => changeInputSpec(spec, value)"></el-input>
                <span style="font-size: 12px">{{ scoped.row.productSpec }}</span>
                <el-switch
                    v-if="scoped.row.id"
                    v-model="scoped.row.isActive"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    style="margin-left: 10px"
                >
                </el-switch>
              </template>
            </el-table-column>
            <el-table-column
                label="商品编码"
                :render-header="button">
              <template slot-scope="scoped">
                <el-input type="text" v-model="scoped.row.productCode"></el-input>
              </template>
            </el-table-column>
            <el-table-column
                :render-header="button1"
                label="成本价格">
              <template slot-scope="scoped">
                <el-input class="cost-price" type="number" placeholder="价格必须大于零" v-model="scoped.row.costPrice"
                          @input="(value) => watchCostPrice(value, scoped.row)"></el-input>
              </template>
            </el-table-column>
            <el-table-column
                :render-header="button2"
                label="属性图">
              <template slot-scope="scoped">
                <div class="cell up_img">
                  <div class="el_upload_sku">
                    <input
                        class="el_upload_input"
                        @change="handleSkuChange($event, scoped.row.index)"
                        id="el_upload_input"
                        type="file"
                    />
                    <img
                        v-if="scoped.row.pictureUrl"
                        :src="scoped.row.pictureUrl"
                        class="avatar"
                    />
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    <span
                        class="mask"
                        v-if="scoped.row.pictureUrl"
                        @click.stop="delSkuPic(scoped.row.index)"
                    >
                        <i class="el-icon-delete"></i>
                      </span>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
                label="操作">
              <template slot-scope="scoped">
<!--                saleableSkuPriceItems []  有值不让删除  高瑶说的 -->
                <el-button v-if="!(scoped.row.saleableSkuPriceItems.length && scoped.row.saleableSkuPriceItems.length > 0)" size="mini" type="danger" @click="deleteSku(scoped.row, scoped.row.index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <div class="sbmit_info" v-if="createSkuList[0]">
      <el-button type="primary" v-preventClick @click="handleSubmitSku">保存SKU</el-button>
    </div>
    <!-- 图片放大 -->
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" height="100%" :src="dialogImageUrl" alt/>
    </el-dialog>
    <!-- 选择属性组合 -->
    <el-dialog title="选择属性组合" width="35%" :visible.sync="dialogCombination" :append-to-body="true">
      <el-table ref="diaTable" border max-height="500px" :data="skuPreViewList" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" align="center"></el-table-column>
        <el-table-column label="规格名称" prop="productSpec" align="left"></el-table-column>
      </el-table>
      <div slot="footer">
        <el-button type="primary" @click="confrimSku">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="自由组合" :visible.sync="dialogMaintain" v-if="dialogMaintain">
      <maintain :groupId="goodDetailForm.propertyGroupId" :checkList="checkList"
                @getPropertyValue="getPropertyValue"></maintain>
    </el-dialog>
  </div>
</template>

<script>
import {
  ProductCreate, //上传商品
  getQiniuToken,
  CategoryGetTree, //获取商品类型
  brandGetAll, //品牌列表
  PropertyGroupGetAll,
  GetProductSkuPreView,
  GetProducDetail,
  BatchCreateAndUpdate,
  ProductSkuGetAllNew,
  ProductSkuDelete,
  ProductUpdate, //商品编辑
  GetAllProperties,
  AddPicture,
  DeletePicture,
  UpdatePicture,
  GetAllSupplier
} from "../../../api/api";
import draggable from "vuedraggable";
import weditor from "../../../components/WangEditor";
import {getButtonList} from "../../../promissionRouter";
import maintain from "./components/maintain.vue"

export default {
  components: {
    weditor,
    draggable,
    maintain,
  },
  watch: {
    // "goodDetailForm.categoryId": {
    //   handler(n, o) {
    //     this.getPropertyList(n)
    //   },
    //   deep: true
    // },
    "goodDetailForm.propertyGroupId": {
      handler(n, o) {
        this.getAllProperties(n)
      },
      deep: true
    },
    "goodDetailForm.pictures": {
      handler(n, o) {
        if (n.length) {
          this.skuMainpic = n[n.findIndex(val => val.type == 0)].url
        }
        if (n.length >= 9) {
          this.isShowNinePic = true
        } else {
          this.isShowNinePic = false
        }
      },
      deep: true
    }
  },
  data() {
    return {
      isShowNinePic: false, // 最多显示图片
      dialogMaintain: false,
      dialogCombination: false, // 属性组合展示
      spuId: this.$route.query.id ? this.$route.query.id : null,
      qiniuToken: "",
      brandList: [], // 品牌列表
      goodDetailForm: {
        categoryId: null,
        categorys: [],
        name: null, //商品名称
        model: null, //型号
        brandId: null, //商品品牌
        brandName: '',
        order: null,
        serviceContent: '',
        code: '',
        introduce: '',
        isActive: true,
        pictures: [],
        propertyGroupId: null,
        propertyGroupName: '',
        properties: [],
        sourceType: null,
        sourceId: null
      },
      propertyList: [], // 属性模板
      skuPreViewList: [], // 规格组合
      checkedSkuList: [],
      productNavTypeTreeList: [], //商品类型
      createSkuList: [], //规格最终生成的数组
      dialogVisible: false,
      dialogImageUrl: "",
      checkList: [],
      supplierList: [],

      categoryId: 0,
      resList: [],
      skuMainpic: null
    };
  },
  // beforeRouteEnter(to, from, next) {
  //   console.log(to, from, '路由')
  //   if (from.path == "/Product/AttributeTemplate/Maintain") {
  //     to.meta.keepAlive = true;
  //   } else {
  //     to.meta.keepAlive = false;
  //   }
  //   next();
  // },
  created() {
    if (this.$route.query.id) {
      this.getSpuDetail()
      this.getSkuList()
    }
    this.getPropertyList()
    this.getQiniuToken();
    this.getProductNavTypeTree();
    this.getBrandList();
    this.getSupplierList();
  },
  methods: {
    button2() {
      return (
          <div>
            <span style="margin-right:5px;">属性图</span>
            <el-button on-click={() => this.copyPictureUrl()} type="primary" size="small">向下覆盖</el-button>
          </div>
      )
    },
    button1() {
      return (
          <div>
            <span style="margin-right:5px;">成本价</span>
            <el-button on-click={() => this.copyCostPrice()} type="primary" size="small">向下覆盖</el-button>
          </div>
      )
    },
    button() {
      return (
          <div>
            <span style="margin-right:5px;">商品编码</span>
            <el-button on-click={() => this.copyProductCode()} type="primary" size="small">向下覆盖</el-button>
          </div>
      )
    },
    tableRowClassName({row, rowIndex}) {
      row.index = rowIndex;
    },
    select_blur_supplier() {
      this.getSupplierList();
    },
    getSupplierList() {
      let params = {
        SkipCount: 0,
        MaxResultCount: 200
      };
      let that = this;
      GetAllSupplier(params).then((res) => {
        if (res.data.success) {
          that.supplierList = res.data.result.items;
        }
      });
    },
    watchCostPrice(val, data) {
      if (val <= 0) {
        data.costPrice = null
      }
    },
    getAllProperties() {
      GetAllProperties({PropertyGroupId: this.goodDetailForm.propertyGroupId, showAll: true}).then(res => {
        if (res.data.success) {
          let arr = res.data.result.items || []
          let list = []
          arr.forEach(item => {
            item.propertyValues.forEach(val => {
              list.push({
                propertyId: item.propertyId,
                propertyString: item.propertyName,
                propertyValueId: val.propertyValueId,
                propertyValueString: val.propertyValueString
              })
            })
          })
          this.goodDetailForm.properties = list
        }
      })
    },
    goJumpAttributeTem() {
      if (!this.goodDetailForm.propertyGroupId) {
        return this.$message.warning('请选择属性模板！')
      }
      this.dialogMaintain = true
      // this.$router.push(`/Product/AttributeTemplate/Maintain?groupId=${this.goodDetailForm.propertyGroupId}`)
    },
    getBrandList(key) {
      let obj = {
        IsActive: true,
        SkipCount: 0,
        MaxResultCount: 10000,
      };
      if (key) {
        obj.name = key;
      }
      return new Promise((resolve, reject) => {
        brandGetAll(obj).then((res) => {
          if (res.data.success) {
            this.brandList = res.data.result.items.map((item) => {
              return {
                value: item.name,
                id: item.id,
              };
            });
            resolve(this.brandList);
          } else {
            this.$message.error(res.data.msg);
            reject(res.data.msg);
          }
        });
      });
    },
    async querySearchAsync(queryString, cb) {
      if (queryString) {
        let res = await this.getBrandList(queryString);
        cb(res);
      } else {
        let res = await this.getBrandList();
        cb(res);
      }
    },
    handleSelect(item) {
      this.goodDetailForm.brandId = item.id;
    },
    getPropertyList(key) {
      let obj = {
        // CategoryId: key,
        IsActive: true,
        SkipCount: 0,
        MaxResultCount: 100,
      };
      PropertyGroupGetAll(obj).then((res) => {
        this.propertyList = res.data.result.items || []
      })
    },
    // spu详情
    getSpuDetail() {
      GetProducDetail({id: this.spuId}).then(res => {
        if (res.data.success) {
          this.goodDetailForm = {...res.data.result, categorys: []} || {}
          this.getProductNavTypeTree(() => {
            // 赋值分类
            this.categoryId = res.data.result.categoryId
            this.getCategoryItems()
          });
          // const cateList = res.data.result.categoryJson
          // if (cateList) {
          //   JSON.parse(cateList).forEach(item => {
          //     this.goodDetailForm.categorys.push({
          //       id: item.CategoryId,
          //       name: item.CategoryName
          //     })
          //   })
          // }
          if (this.goodDetailForm.sourceType === 0) {
            this.goodDetailForm.sourceId = null;
          }
          this.goodDetailForm.introduce = res.data.result.introduce;
          let arr = res.data.result.properties || []
          this.checkList = this.listToTree(arr)
        }
      })
    },
    getCategoryItems() {
      let targId = this.categoryId
      let list = this.productNavTypeTreeList

      this.loopFunc(list)

      let result = []
      let res = this.resList.find(i => i.value === targId)
      result.push(res)
      if (res.pId > 0) {
        let res1 = this.resList.find(i => i.value === res.pId)
        result.push(res1)
        if (res1.pId > 0) {
          let res2 = this.resList.find(i => i.value === res1.pId)
          result.push(res2)
        }
      }
      // console.log('result---', result)
      this.goodDetailForm.categorys = result.reverse().map(i => {
        return {
          categoryId: i.value,
          categoryName: i.label
        }
      })
    },
    loopFunc(list) {
      for (var i = 0; i < list.length; i++) {
        this.resList.push({
          label: list[i].label,
          pId: list[i].pId,
          value: list[i].value
        })
        if (list[i].children && list[i].children.length) {
          this.loopFunc(list[i].children)
        }
      }
    },
    listToTree(arr) {
      let list = []
      arr.forEach(item => {
        let id = item.propertyId
        let index = list.findIndex(val => val.id == item.propertyId)
        if (index > -1) {
          list[index].checkedCities.push(item.propertyValueId)
        } else {
          list.push({
            id: item.propertyId,
            checkedCities: [item.propertyValueId]
          })
        }
        // if (obj.hasOwnProperty(item.checkedCities)) {
        //   list[obj[item.id]][item.checkedCities] = item.propertyId
        //   list[obj[item.propertyId]][item.checkedCities] = item.propertyValueId
        // } else {
        //   obj[item.propertyId] = index++
        //   list.push({
        //     id: item.propertyId,
        //     checkedCities: [item.propertyValueId]
        //   })
        // }
      })
      // console.log(arr, list)
      return list
    },
    catchDetailData(data) {
      this.goodDetailForm.introduce = data;
    },
    // getObjByTree1(data, id) {
    //   let result = null
    //   if (!data) return // return; 中断执行
    //   for (let i in data) {
    //     if (result !== null) break
    //     let item = data[i];
    //     if (item.id === id) {
    //       result = item;
    //       break;
    //     } else if (!!item?.childs?.length) {
    //       result = this.getObjByTree(item.childs, id);
    //     }
    //   }
    //   return result;
    // },
    getItemByIdInTree(id, tree) {
      // debugger
      let res = null
      for (let i = 0; i < tree.length; i++) {
        let ele = tree[i]
        if (ele.children && ele.children.length) {
          res = this.getItemByIdInTree(id, ele.children)
        } else {
          ele.value === id ? res = ele : ''
          if (res) break;
        }
      }
      return res
    },
    getPath(data, id) {
      let path = [];
      data.forEach((item, index) => {
        path[0] = {categoryId: item.value, categoryName: item.label};
        if (item.value === id) {
          return path
        }

        if (item.children && item.children.length) {

        }

        if (item.children && item.children.length > 0) {
          item.children.forEach((item1, index1) => {
            if (item1.value === id) {
              // path.push({categoryId:item1.value, categoryName:item1.label})
              // path.unshift({...item1})
              path[1] = {categoryId: item1.value, categoryName: item1.label};
            } else {
              if (item1.children && item1.children.length > 0) {
                item1.children.forEach((item2, index2) => {
                  if (item2.value === id) {
                    // path.push({categoryId:item2.value, categoryName:item2.label});
                    // path.unshift({...item2});
                    path[2] = {categoryId: item2.value, categoryName: item2.label};
                  }
                })
              }
            }
          })
        }

      })
    },

    query(arr, id) {
      let data = [];
      arr.forEach(item => {
        if (item.value === id) {
          data.push(item)
        }
        if (item.children) {
          this.query(item.children, id)
        }
      })
      return data;
    }
    ,
    // 商品类型
    getProductNavTypeTree(callback) {
      let that = this;
      CategoryGetTree({parentId: 0, isActive: true}).then((res) => {
        that.productNavTypeTreeList = this.loopMenuTree(res.data.result.children);
        // console.log(that.productNavTypeTreeList, 'kkkkk')
        callback && callback()

      });
    },
    loopMenuTree(treeList) {
      const newList = treeList.filter(item => {
        item.value = item.data.Id;
        item.pId = item.data.ParentId
        item.label = item.data.Name;
        delete item.data
        if (!item.children.length) {
          delete item.children
        } else {
          this.loopMenuTree(item.children)
        }
        return true;
      })
      return newList;
    },
    //获取七牛token
    getQiniuToken() {
      var that = this;
      getQiniuToken().then((res) => {
        that.qiniuToken = res.data;
      })
          .catch(() => {
          });
    },
    handleDelPic(item, index) {
      this.$confirm("确认删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        closeOnClickModal: false,
        type: "warning",
      }).then(() => {
        //   let data = {
        //   ProductId: this.spuId,
        //   ProductPictureId: item.id
        // }
        // console.log(data)
        // DeletePicture(data).then(res => {
        //   if (res.data.success) {
        //     this.$message.success('删除成功！')
        //   } else {
        //     this.$message.error(res.data.error.message)
        //   }
        // })
        this.deletePicture(item)
        // this.goodDetailForm.pictures.splice(index, 1);
      }).catch(() => {
      })
    },
    handleBusinessPic(file) {
      let that = this;
      let fileSuf = file.name.split(".")[1];
      let qiniuData = {
        key: `KSAX/System/image/${new Date().getTime()}.${fileSuf}`,
        token: that.qiniuToken,
      };
      that.$utils.uploadImgToQiniu(file.raw, qiniuData)
          .then((res) => {
            // let itemPic;
            // if (that.goodDetailForm.pictures[0]) {
            //   itemPic = {
            //     url: res,
            //     type: 1,
            //   };
            // } else {
            //   itemPic = {
            //     url: res,
            //     type: 0,
            //   };
            // }
            // that.goodDetailForm.pictures.push(itemPic);
            that.uploadPicture(res)
          }).catch((err) => {
        that.$message.error(err);
      });
    },
    uploadPicture(url) {
      let data = {
        productId: this.spuId,
        url: url,
        type: 1
      }
      AddPicture(data).then(res => {
        if (res.data.success) {
          this.$message.success('添加成功！')
          this.getSpuDetail()
        } else {
          this.$message.error(res.data.error.message)
        }
      })
    },
    deletePicture(item) {
      let data = {
        productId: this.spuId,
        productPictureId: item.id
      }
      // console.log(data)
      DeletePicture(data).then(res => {
        if (res.data.success) {
          this.$message.success('删除成功！')
          this.getSpuDetail()
        } else {
          this.$message.error(res.data.error.message)
        }
      })
    },
    updatePicture(item) {
      let data = {
        productId: this.spuId,
        productPictureId: item.id,
        type: item.type == 1 ? 0 : 1
      }
      UpdatePicture(data).then(res => {
        if (res.data.success) {
          this.$message.success('设置成功！')
          this.getSpuDetail()
        } else {
          this.$message.error(res.data.error.message)
        }
      })
    },
    // 属性组合
    selectScep() {
      GetProductSkuPreView({ProductId: this.spuId}).then(res => {
        if (res.data.success) {
          // console.log('resss', res);
          this.dialogCombination = true
          this.skuPreViewList = res.data.result || []
          // return;
          this.$nextTick(() => {
            this.createSkuList.forEach(row => {
              let index = this.skuPreViewList.findIndex(i => {
                return i.speCode === row.speCode
              })
              if (index > -1) {
                // this.$set(this.skuPreViewList[i].items[findTargIndex], 'isCheck', true)
                this.$refs.diaTable.toggleRowSelection(this.skuPreViewList[index])
              }
            })
          })
        }
      })
      // console.log('this.createSkuList', this.createSkuList)
    },
    getPropertyValue(arr) {
      // console.log(arr, 'dddd')
      this.dialogMaintain = false
      this.goodDetailForm.properties = arr
    },
    // 添加/编辑商品
    addOrUpdata() {
      let that = this;
      if (!that.goodDetailForm.categoryId)
        return that.$message.error("请选择商品类型！");
      if (!that.goodDetailForm.name)
        return that.$message.error("请输入商品名称！");
      if (!that.goodDetailForm.model)
        return that.$message.error("请输入商品型号！");
      if (!that.goodDetailForm.brandId)
        return that.$message.error("请选择商品品牌！");
      // if (that.goodDetailForm.sourceType === 1 && that.goodDetailForm.sourceId === null)
      //   return that.$message.error("请选择供应商");
      if (!that.goodDetailForm.propertyGroupId && that.goodDetailForm.propertyGroupId !== 0)
        return that.$message.error("请选择属性模板！");
      // if (!that.goodDetailForm.pictures[0])
      //   return that.$message.error("请上传商品商家端展示图册！");
      if (!that.goodDetailForm.introduce)
        return that.$message.error("请填写商品描述！");
      delete that.goodDetailForm.pictures
      // console.log(that.goodDetailForm, '商品信息')
      let params = JSON.parse(JSON.stringify(that.goodDetailForm));
      if (params.sourceId === null) {
        params.sourceId = 0;
      }
      that.$confirm("确认提交吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        closeOnClickModal: false,
        type: "warning",
      })
          .then(() => {
            // if (!that.$route.query.id) {
            //   ProductCreate(that.goodDetailForm).then((res) => {
            //     if (res.data.success) {
            //       that.$message.success('添加成功！');
            //       this.spuId = res.data.result.id
            //       // this.$router.go(0);
            //     } else {
            //       // that.$message.error(res.data.msg);
            //     }
            //   });
            // } else {
            ProductUpdate(params).then((res) => {
              if (res.data.success) {
                that.$message.success('编辑成功！');
                // this.getProductSpuDetail();
                // this.$router.go(0);
              } else {
                // that.$message.error(res.data.msg);
              }
            });
            // }
          });
    },
    handleChange(value) {
      this.goodDetailForm.categorys = []
      let {path, pathLabels} = this.$refs['cascader'].getCheckedNodes()[0]
      path.forEach((item, i) => {
        this.goodDetailForm.categorys.push({
          categoryId: item, categoryName: pathLabels[i]
        })
      })
    },
    handleSelectionChange(arr) {
      this.checkedSkuList = arr
    },
    confrimSku() {
      let list = []
      this.checkedSkuList.forEach(item => {
        list.push({
          // "productId": item.productId,
          "speCode": item.speCode,
          "productSpec": item.productSpec,
          "productSpecExt": item.productSpec,
          "propertyJson": item.propertyJson,
          "propertyJsonArr": JSON.parse(item.propertyJson),
          "productCode": "",
          "pictureUrl": this.skuMainpic,
          "costPrice": null,
          "isActive": true,
          "saleableSkuPriceItems": []
        })
      })
      if (!this.createSkuList[0]) {
        this.createSkuList = list
      } else {
        list.forEach(item => {
          item.propertyJsonArr.PropertyList.forEach(val => {
            this.createSkuList.forEach(item2 => {
              item2.propertyJsonArr.PropertyList.forEach(val2 => {
                if (val2.PropertyValueId == val.PropertyValueId) {
                  val.PropertyValueString = val2.PropertyValueString
                }
              })
            })
          })
        })
        this.createSkuList = this.arrayDup(this.createSkuList, list)
      }
      console.log(this.createSkuList,'this.createSkuList')
      this.dialogCombination = false
    },
    // 处理同一属性名称
    changeInputSpec(spec,value) {
      this.createSkuList.forEach(item => {
        item.propertyJsonArr.PropertyList.forEach(val => {
          if (spec.PropertyValueId == val.PropertyValueId) {
            val.PropertyValueString = value
          }
        })
      })
    },
    // 去重
    arrayDup(arr1, arr2) {
      let list1 = [], list2 = []
      for (let i = 0; i < arr1.length; i++) {
        for (let j = 0; j < arr2.length; j++) {
          if (arr1[i].speCode == arr2[j].speCode) {
            list1.push(arr1[i])
          }
        }
      }
      arr2.forEach(item => {
        let index = arr1.findIndex(i => {
          return i.speCode === item.speCode
        })
        if (index < 0) {
          list2.push(item)
        }
      })
      return list1.concat(list2)
    },
    // 保存sku
    handleSubmitSku() {
      // 校验成本价不能为空
      let elements = document.querySelectorAll('#container .cost-price input');
      for (let el of elements) {
        el.classList.remove("input-err");
      }
      for (let el of elements) {
        if (isNaN(el.valueAsNumber)) {
          el.classList.add("input-err");
          return this.$message.error('成本价不能为空');
        }
      }

      // console.log(this.createSkuList,'createSkuList')
      // let list = this.createSkuList
      let items = JSON.parse(JSON.stringify(this.createSkuList))
      if (items.length) {
        items.forEach(i => {
          i.productSpecExt = ''
          i.propertyJsonArr.PropertyList.forEach(v => {
            i.productSpecExt += `${v.PropertyString}*`
          })
          i.propertyJsonExt = JSON.stringify(i.propertyJsonArr)
          i.saleableSkuItems = []
          i.saleableSkuPriceItems.forEach(s => {
              if (s.priceType == 1) {
                  s.retailPrice = s.supplyPrice;
                  s.merchantsPrice = s.supplyPrice;
                  s.marketPrice = s.supplyPrice;
              }
            i.saleableSkuItems.push({
              "saleableSkuId": s.saleableSkuId,
              "supplyPrice": s.supplyPrice,
              "retailPrice": s.retailPrice,
              "merchantsPrice": s.merchantsPrice,
              "marketPrice": s.marketPrice,
              "isShelves": s.isShelves
            })
          })
        })
      }

      let data = {
        productId: this.spuId,
        items
      }
      BatchCreateAndUpdate(data).then(res => {
        if (res.data.success) {
          this.$message.success('保存成功！')
          this.getSkuList()
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    getSkuList() {
      ProductSkuGetAllNew({ProductId: this.spuId}).then(res => {
        let list = res.data.result.items || []
        list.forEach(item => {
          item.propertyJsonArr = JSON.parse(item.propertyJsonExt)
        })
        this.createSkuList = list
        this.$nextTick(() => {
          if (this.createSkuList && this.createSkuList.length > 0) {
            this.$refs.isExpand.toggleRowExpansion(this.createSkuList[0], true);
          }
        })
      })
    },
    deleteSku(data, index) {
      // console.log('index', index)
      // return;
      if (data.id) {
        ProductSkuDelete({ids: [data.id]}).then(res => {
          if (res.data.success) {
            this.getSkuList()
          }
        })
      } else {
        this.createSkuList.splice(index, 1)
      }
    },
    // 图片放大
    handleBigPic(src) {
      this.dialogVisible = true;
      this.dialogImageUrl = src;
    },
    setMain(item, index) {
      let that = this;
      // that.goodDetailForm.pictures.forEach((v, i) => {
      //   if (index == i) {
      //     var arr = [
      //       {
      //         url: that.goodDetailForm.pictures.splice(i, 1)[0].url,
      //         type: 0,
      //       },
      //     ];
      //     that.goodDetailForm.pictures = [
      //       ...arr,
      //       ...that.goodDetailForm.pictures,
      //     ];
      //   }
      // });
      // that.goodDetailForm.pictures.forEach((v, i) => {
      //   if (i > 0) {
      //     v.type = 1;
      //   }
      // });
      that.updatePicture(item)
    },
    handleSkuChange(e, i) {
      let that = this;
      let file = e.target.files[0];
      let fileSuf = file.name.split(".")[1];
      let qiniuData = {
        key: `KSAX/System/image/${new Date().getTime()}.${fileSuf}`,
        token: that.qiniuToken,
      };
      that.$utils.uploadImgToQiniu(file, qiniuData).then((res) => {
        window.document.getElementById("el_upload_input").value = null;
        if (i != null) {
          that.createSkuList[i].pictureUrl = res;
        }
      })
          .catch((err) => {
            that.$message.error(err);
          });
    },
    delSkuPic(i) {
      this.createSkuList[i].pictureUrl = "";
    },
    copyProductCode() {
      // console.log('cover')
      let productCode = ''
      if (this.createSkuList[0].productCode) {
        productCode = this.createSkuList[0].productCode
        this.createSkuList.forEach(item => {
          item.productCode = productCode
        })
      } else {
        this.$message.warning('请先填写第一行内容！')
      }
    },
    copyCostPrice() {
      let costPrice = ''
      if (this.createSkuList[0].costPrice) {
        costPrice = this.createSkuList[0].costPrice
        this.createSkuList.forEach(item => {
          item.costPrice = costPrice
        })
      } else {
        this.$message.warning('请先填写第一行内容！')
      }
    },
    copyPictureUrl() {
      let pictureUrl = ''
      if (this.createSkuList[0].pictureUrl) {
        pictureUrl = this.createSkuList[0].pictureUrl
        this.createSkuList.forEach(item => {
          item.pictureUrl = pictureUrl
        })
      } else {
        this.$message.warning('请先填写第一行内容！')
      }
    },
  },
};
</script>
<style scoped>
.add_main {
  min-height: 100%;
  padding: 10px 20px 100px 20px;
  overflow: hidden;
}

.blue-txt {
  color: #409eff;
}

.el-input,
.el-select,
.el-cascader,
.el-autocomplete {
  width: 300px;
}

.el-textarea {
  width: 500px;
}

.el-form {
  padding-left: 20px;
}

.tab_box {
  padding: 20px;
}

.img_box {
  width: 80px;
  height: 80px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  float: left;
  position: relative;
  margin-right: 10px;
}

.img_box img {
  height: 100%;
  width: 100%;
  border-radius: 6px;
}

.bg_box {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  cursor: default;
  text-align: center;
  color: #fff;
  opacity: 0;
  font-size: 20px;
  background-color: rgba(0, 0, 0, 0.5);
  transition: opacity 0.3s;
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin: 0;
}

.bg_box:hover {
  opacity: 1;
}

.del_box {
  position: absolute;
  top: -10px;
  right: -10px;
  width: 20px;
  height: 20px;
}

.del_box img {
  height: 100%;
  width: 100%;
}

.img-uploader {
  display: inline-block;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  overflow: hidden;
}

.img-uploader:hover {
  border-color: #409eff;
}

.img-uploader .el_upload {
  height: 80px;
  width: 80px;
}

.el-upload img {
  height: 100%;
  width: 100%;
  border-radius: 6px;
}

.avatar-uploader-icon {
  font-size: 24px;
  color: #8c939d;
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
}

.avatar {
  width: 80px;
  height: 80px;
  display: block;
}

.set_main {
  position: absolute;
  bottom: -40px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.set-share {
  position: absolute;
  bottom: -70px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.params_box div {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 10px;
}

.from_tit {
  color: #606266;
  margin-right: 20px;
}

.params_box ul {
  list-style: none;
  margin: 0;
  padding: 0 20px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.params_box ul > li {
  padding: 0 10px;
  color: #fff;
  border-radius: 15px;
  font-size: 14px;
  margin-right: 20px;
}

.el_upload_input {
  height: 100px;
  width: 100px;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  z-index: 99;
}

.single_up_img {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.el_upload_sku {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 100px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.el_upload_sku:hover {
  border-color: #409eff;
}

.el_upload_sku:hover .mask {
  opacity: 1;
}

.mask {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  cursor: default;
  text-align: center;
  line-height: 178px;
  color: #fff;
  opacity: 0;
  font-size: 20px;
  background-color: rgba(0, 0, 0, 0.5);
  transition: opacity 0.3s;
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.el-table {
  border: 1px solid #999;
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
  flex: 1;
  width: 100%;
  max-width: 100%;
  font-size: 14px;
  color: #606266;
  background-color: #fff;
}

.el-table table {
  width: 100% !important;
  max-width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
}

.el-table thead {
  color: #909399;
  table-layout: fixed;
  border-collapse: separate;
  font-weight: 500;
}

.el-table th,
.el-table tr {
  background: #fff;
}

.el-table .el-table__body td,
.el-table .el-table__header tr th {
  padding: 0;
  background: #f6f7f9;
  border-right: 1px solid #dde5e8;
  border-bottom: 1px solid #dde5e8;
  text-align: center;
  overflow: hidden;
  user-select: none;
  box-sizing: border-box;
  text-overflow: ellipsis;
  vertical-align: middle;
  position: relative;
}

.el-table .el-table__header th:first-child div.cell {
  border-left: 0;
  background: #f6f7f9;
  padding: 7px 8px;
  font-weight: 100;
  font-size: 12px;
  box-sizing: border-box;
  position: relative;
  vertical-align: middle;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  word-break: break-all;
  line-height: 23px;
}

.el-table__body,
.el-table__footer,
.el-table__header {
  table-layout: fixed;
  border-collapse: separate;
}

.el-table th,
.el-table tr {
  background-color: #fff;
  box-sizing: border-box;
  text-align: center;
  width: 100px;
  border-right: 1px solid #dfe6ec;
}

.el-table .el-table__body td div.cell {
  font-size: 12px;
  padding: 9px 8px;
  box-sizing: border-box;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  word-break: break-all;
  line-height: 23px;
}

.cell .el-input {
  width: 100%;
}

.avatar-box {
  height: 100px;
  width: 100px;
}

.up_img {
  display: flex;
  justify-content: center;
  align-items: center;
}

.sbmit_info {
  padding: 20px;
  display: flex;
  justify-content: center;
  width: 100%;
}

#container /deep/ .cost-price input.input-err {
  border: #F56C6C solid 1px;
}

</style>
